export const isServer = (): boolean => typeof window === 'undefined'

export const isProduction = (): boolean =>
  // eslint-disable-next-line no-process-env
  process.env.NODE_ENV === 'production'
